import { ensureConfig, getConfig } from "@edx/frontend-platform";
import { getAuthenticatedHttpClient } from "@edx/frontend-platform/auth";
import { AppContext } from "@edx/frontend-platform/react";
import React, { useContext, useEffect, useRef, useState } from "react";
import IIMBLogo from "../assets/images/iimb-logo.png";
import Logo from "../assets/images/logo.png";

ensureConfig(
  [
    "LMS_BASE_URL",
    "LOGOUT_URL",
    "LOGIN_URL",
    "SITE_NAME",
    "LOGO_URL",
    "ORDER_HISTORY_URL",
  ],
  "Header component"
);

const Header = ({ children, isSpecificStudent }) => {
  const { authenticatedUser, config } = useContext(AppContext);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const [profileImage, setProfileImage] = useState(
    `${getConfig().LMS_BASE_URL}/static/images/profiles/default_50.png`
  );
  const [link, setlink] = useState("#");
  const isStaffOrInstructor = authenticatedUser?.administrator;

  useEffect(() => {
    const fetchUserProfile = async () => {
      if (authenticatedUser) {
        try {
          console.log(`Fetching profile for user: ${config.LMS_BASE_URL}`);
          const url = `${getConfig().LMS_BASE_URL}/api/user/v1/accounts/${
            authenticatedUser?.username && authenticatedUser?.username
          }`;
          const response = await getAuthenticatedHttpClient().get(url);

          setProfileImage(response?.data?.profile_image?.image_url_small);
        } catch (error) {
          console.error("Error fetching user profile:", error);
        }
      }
    };

    fetchUserProfile();
  }, [authenticatedUser, config.LMS_BASE_URL]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const toggleDropdown = (e) => {
    e.stopPropagation();
    setIsDropdownOpen(!isDropdownOpen);
  };

  function getCookie(cookieName) {
    try {
      const cookies = document.cookie.split(';');
      for (const cookie of cookies) {
        const [name, value] = cookie.trim().split('=');
        if (name === cookieName) {
          const decodedValue = decodeURIComponent(value);
          return decodedValue;
        }
      }
      return null;
    } catch (error) {
      console.error('Error reading cookie:', error);
      return null;
    }
  }

  function getResumeBlockFromCookie() {
    try {
      const edxUserInfo = getCookie('edx-user-info');
      if (!edxUserInfo) {
        return "" || "#";
      }
      const cleanedInfo = edxUserInfo?.replace(/\\"/g, '"').replace(/^"|"$/g, '') || '';
      const resumeBlockMatch = cleanedInfo?.match(/resume_block\"\s*:\s*\"([^\"]+)\"/) || [];
      if (resumeBlockMatch && resumeBlockMatch[1]) {
        const resumeBlockUrl = resumeBlockMatch[1] || '';
        return resumeBlockUrl;
      }
      return null;
    } catch (error) {
      console.error('Error extracting resume block:', error);
      return null;
    }
  }

  useEffect(() => {
    const resumeBlockUrl = getResumeBlockFromCookie();
    setlink(resumeBlockUrl || '#');
  }, []);

  useEffect(() => {
    if (window.google?.translate) return;

    window.googleTranslateElementInit = () => {
      new window.google.translate.TranslateElement(
        {
          pageLanguage: 'en',
          autoDisplay: false,
        },
        'googleTranslateElement'
      );
    };

    const script = document.createElement('script');
    script.src =
      'https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit';
    script.async = true;
    script.id = 'google-translate-script';

    document.body.appendChild(script);

    return () => {
      delete window.googleTranslateElementInit;
    };
  }, []);

  return (
    <>
    <header className="header learning_header" translate="no">
      <nav className={`navbar navbar-expand-lg navbar-light bg-light  ${isSpecificStudent ? "specific-student":""}`}>
        <div className="container-fluid">
          <div className="navbar-brand">
            <a href={config.LMS_BASE_URL} className="logo-container">
              <img src={IIMBLogo} alt="Logo" className="iimb-logo"/>
              <div class="divider"></div>
              <img src={Logo} alt="Logo" className="iimbx-logo" />
            </a>
          </div>
          {children}
          <div className="languages-form" id="languagesForm">
            <div id="googleTranslateElement"></div>
          </div>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav">
              <li className="nav-item dropdown" ref={dropdownRef}>
                <a
                  className="nav-link dropdown-toggle"
                  href="#"
                  id="navbarDropdown"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  onClick={toggleDropdown}
                >
                  <div className="profile">
                    <img src={profileImage} alt="Profile" />
                  </div>
                  <span>{authenticatedUser?.username}</span>
                </a>
                <ul
                  className="dropdown-menu"
                  aria-labelledby="navbarDropdown"
                  style={{
                    display: isDropdownOpen ? "block" : "none",
                  }}
                >
                  {link !== "#" && (
                    <>
                      <li>
                        <a
                          className="dropdown-item"
                          href={link}
                        >
                          Resume your last course
                        </a>
                      </li>
                    </>
                  )}
                  <li>
                    <a
                      className="dropdown-item"
                      href={`${config?.LMS_BASE_URL}/dashboard`}
                    >
                      Dashboard
                    </a>
                  </li>
                  <li>
                    <a
                      className="dropdown-item"
                      href={`${config?.LMS_BASE_URL}/dashboard/programs/`}
                    >
                      Programs
                    </a>
                  </li>
                  <li>
                    <a
                      className="dropdown-item"
                      href={`${config?.ACCOUNT_PROFILE_URL}/u/${authenticatedUser?.username}`}
                    >
                      Profile
                    </a>
                  </li>
                  <li>
                    <a
                      className="dropdown-item"
                      href={`${config?.ACCOUNT_SETTINGS_URL}`}
                    >
                      {" "}
                      Your Account
                    </a>
                  </li>
                  {isStaffOrInstructor && (
                      <>
                        <li>
                          <a className="dropdown-item" href={`${config.LMS_BASE_URL}/learner-engagement-dashboard`}>
                            Learner Engagement Dashboard
                          </a>
                        </li>
                        <li>
                          <a className="dropdown-item" href={`${config.LMS_BASE_URL}/program-dashboard`}>
                            Program Dashboard
                          </a>
                        </li>
                      </>
                  )}
                  <li>
                    <a className="dropdown-item" href={config?.LOGOUT_URL}>
                      Sign Out
                    </a>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </nav>
      </header>
    </>
  );
};

export default Header;
